import { CommunityRoles, CommunityUser } from 'types';

export const getEligibleCommunityRecipients = (
  users: CommunityUser[] = [],
): CommunityUser[] =>
  users.filter(
    (user) => user.communityPermission?.role !== CommunityRoles.BLOCKED,
  );

export const getMaxCommunityRecipients = (
  users: CommunityUser[] = [],
): number => getEligibleCommunityRecipients(users).length;
